var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneWhats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 213.1 429.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e465d;}.cls-2{fill:#706f6f;}.cls-3{fill:#1d1d1b;}.cls-23,.cls-4{fill:#5b2e87;}.cls-5{fill:url(#Gradiente_sem_nome);}.cls-6{fill:url(#Gradiente_sem_nome_2);}.cls-7{fill:url(#Gradiente_sem_nome_3);}.cls-8{fill:url(#Gradiente_sem_nome_4);}.cls-9{fill:url(#Gradiente_sem_nome_5);}.cls-10{fill:url(#Gradiente_sem_nome_6);}.cls-11{fill:url(#Gradiente_sem_nome_7);}.cls-12{fill:url(#Gradiente_sem_nome_8);}.cls-13{fill:url(#Gradiente_sem_nome_9);}.cls-14{fill:url(#Gradiente_sem_nome_10);}.cls-15{fill:url(#Gradiente_sem_nome_11);}.cls-16{fill:url(#Gradiente_sem_nome_12);}.cls-17{isolation:isolate;}.cls-18{fill:url(#Gradiente_sem_nome_13);}.cls-19{fill:url(#Gradiente_sem_nome_14);}.cls-20{fill:url(#Gradiente_sem_nome_15);}.cls-21{fill:url(#Gradiente_sem_nome_16);}.cls-22{fill:#37d616;}.cls-22,.cls-23{fill-rule:evenodd;}.cls-24{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome",
    x1: -1485.9,
    y1: 1779.51,
    x2: -1434.1,
    y2: 1779.51,
    gradientTransform: "matrix(0, 1, 1, 0, -1567.61, 1595.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68595f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#896e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2b1d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#704a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2b1d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4a5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2",
    x1: -1485.92,
    y1: 1780.41,
    x2: -1434.12,
    y2: 1780.41,
    gradientTransform: "matrix(0, 1, 1, 0, -1532.91, 1595.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#654e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#786f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#786f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#654e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    x1: -1496.8,
    y1: -1921.19,
    x2: -1464,
    y2: -1921.19,
    gradientTransform: "translate(-1920.44 1595.7) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68595f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#896e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#704a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4a5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    x1: -1496.8,
    y1: -1920.64,
    x2: -1464,
    y2: -1920.64,
    gradientTransform: "translate(-1885.74 1595.7) rotate(90)",
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_5",
    x1: 36.2,
    y1: 20.3,
    x2: 36.2,
    y2: 53.1,
    gradientTransform: "matrix(1, 0, 0, -1, -34.7, 152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68595f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4a5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    x1: -1455.6,
    y1: -1921.19,
    x2: -1422.8,
    y2: -1921.19,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7",
    x1: -1455.56,
    y1: -1920.64,
    x2: -1422.76,
    y2: -1920.64,
    gradientTransform: "translate(-1885.74 1595.7) rotate(90)",
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_8",
    x1: 36.2,
    y1: -20.94,
    x2: 36.2,
    y2: 11.86,
    xlinkHref: "#Gradiente_sem_nome_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_9",
    x1: -1527.82,
    y1: -1921.19,
    x2: -1510.98,
    y2: -1921.19,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_10",
    x1: -1527.8,
    y1: -1920.64,
    x2: -1510.97,
    y2: -1920.64,
    gradientTransform: "translate(-1885.74 1595.7) rotate(90)",
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_11",
    x1: 36.2,
    y1: 67.28,
    x2: 36.2,
    y2: 84.12,
    xlinkHref: "#Gradiente_sem_nome_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12",
    x1: 155.2,
    y1: 125.97,
    x2: 155.2,
    y2: 131.83,
    gradientTransform: "matrix(1, 0, 0, -1, -34.7, 152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13",
    x1: -2984.58,
    y1: 1405.43,
    x2: -2984.58,
    y2: 1408.78,
    gradientTransform: "matrix(-1, 0, 0, 1, -2864.08, -1383.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b131c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14",
    x1: 265.9,
    y1: 93.11,
    x2: 263.8,
    y2: 95.22,
    gradientTransform: "matrix(1, 0, 0, -1, -109.64, 117.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#222326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1f2c37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1a3d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#13537c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0b71ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0094ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0095ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0488d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0d689f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#154e72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1b394e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1f2b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#222225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradiente_sem_nome_15",
    cx: 264.84,
    cy: 94.16,
    r: 1.49,
    gradientTransform: "matrix(1, 0, 0, -1, -109.64, 117.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#175168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0d78a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0695cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#02a7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#02a6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0693c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0e749c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#184a5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradiente_sem_nome_16",
    cx: 265.66,
    cy: 93.38,
    r: 0.53,
    gradientTransform: "matrix(1, 0, 0, -1, -109.64, 117.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phoneWhats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.1,0H212.4A33.61,33.61,0,0,1,246,33.6V396a33.61,33.61,0,0,1-33.6,33.6H70.1A33.61,33.61,0,0,1,36.5,396V33.6A33.67,33.67,0,0,1,70.1,0Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.1,1H70.4A32.84,32.84,0,0,0,37.5,33.8h0V395.7a32.82,32.82,0,0,0,32.8,32.8H212.1a32.82,32.82,0,0,0,32.8-32.8V33.8A32.69,32.69,0,0,0,212.1,1ZM244,395.5a32.14,32.14,0,0,1-32.1,32.1H70.7a32.14,32.14,0,0,1-32.1-32.1V34.1A32.07,32.07,0,0,1,70.7,2H211.9A32.14,32.14,0,0,1,244,34.1h0Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71,3.3H211.6a30.92,30.92,0,0,1,30.9,30.9V395.5a30.92,30.92,0,0,1-30.9,30.9H71a30.92,30.92,0,0,1-30.9-30.9V34.2A30.86,30.86,0,0,1,71,3.3Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.4,10.1h16.4a24.09,24.09,0,0,1,24.1,24V395.3a24,24,0,0,1-24.1,24H70.8a24.09,24.09,0,0,1-24.1-24V34.2a24,24,0,0,1,24.1-24H195.4Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.3,
    y: 109.8,
    width: 1.2,
    height: 51.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.2,161.5V109.7l.6.7c-.3,5.5-.3,44.9,0,50.4Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.4,
    y: 98.9,
    width: 0.7,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.1,131.7V98.9l-.4.4c.2,3.5.2,28.5,0,32Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1.1,
    y: 98.9,
    width: 0.8,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0.4,
    y: 140.1,
    width: 0.7,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M35.1,172.9V140.1l-.4.4c.2,3.5.2,28.5,0,31.9Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1.1,
    y: 140.1,
    width: 0.8,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 0.4,
    y: 67.9,
    width: 0.7,
    height: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M35.1,84.7V67.9l-.4.4c.2,3.3.2,12.7,0,16Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1.1,
    y: 67.9,
    width: 0.8,
    height: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.1,30.1H123.6a6.74,6.74,0,0,1-6.8-6.8h0a6.74,6.74,0,0,1,6.8-6.8h33.5a6.74,6.74,0,0,1,6.8,6.8h0a6.87,6.87,0,0,1-6.8,6.8Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 120.5,
    cy: 23.2,
    r: 3
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-17",
    width: 6,
    height: 6,
    transform: "translate(117.66 20.4)",
    xlinkHref: "2619E124.png"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 120.5,
    cy: 23.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M156.7,23.2a1.5,1.5,0,1,1-1.5-1.5h0A1.61,1.61,0,0,1,156.7,23.2Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M156.7,23.2a1.5,1.5,0,1,1-1.5-1.5h0A1.61,1.61,0,0,1,156.7,23.2Z",
    transform: "translate(-34.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M156.6,24a.5.5,0,1,0-.5.5.47.47,0,0,0,.5-.5Z",
    transform: "translate(-34.7)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M107.8,219.7c2-6.3,4.2-12.4,6.3-18.6-13.8-24.1,3.3-51.3,26.4-53.6,21.8-2.1,39.8,13.6,39.8,35,.1,22.6-21.9,41.6-46.5,33.9-1.9-.6-4.2-2.5-6.3-2.6-3-.2-7,2-10,3C114.2,217.8,111.3,218.8,107.8,219.7ZM128.3,207c19.9,12.1,43.7-1.5,45.8-21.2a29.29,29.29,0,0,0-31.6-32.4c-21.9,1.6-35.1,27.7-21.6,46.9-1.2,3.3-2.3,6.6-3.3,10C121.2,209.3,124.5,208,128.3,207Z",
    transform: "translate(-34.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M117.5,210.4c1-3.4,2.2-6.8,3.3-10-13.5-19.1-.3-45.3,21.6-46.9A29.24,29.24,0,0,1,174,185.9c-2,19.7-25.9,33.3-45.8,21.2C124.5,208,121.2,209.3,117.5,210.4Zm10.1-31.7c3.2,9,16.4,21.1,26,21.6,4.6.2,10-2.2,9.7-8.6a38.87,38.87,0,0,0-9.3-4.8c-1.6,1.6-2.9,3.6-4.8,4.8a25.18,25.18,0,0,1-13-12.3c5.3-2.9,2.1-9.4,0-13.8C127.9,163.2,125.7,173.4,127.6,178.7Z",
    transform: "translate(-34.7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M136.1,165.7c2.1,4.4,5.3,10.9,0,13.8a25.18,25.18,0,0,0,13,12.3c1.9-1.3,3.2-3.2,4.8-4.8a42.87,42.87,0,0,1,9.3,4.8c.3,6.4-5.1,8.8-9.7,8.6-9.6-.4-22.9-12.6-26-21.6C125.7,173.4,127.9,163.2,136.1,165.7Z",
    transform: "translate(-34.7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M83.4,251.7l-4.2-17.6h3.7l2.7,12.1,3.2-12.1H93l3.1,12.3,2.7-12.3h3.6l-4.3,17.6H94.3l-3.5-13.1-3.5,13.1Z",
    transform: "translate(-34.7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M107.4,234.2v6.5a4.91,4.91,0,0,1,3.9-1.9,4.64,4.64,0,0,1,2.1.4,4,4,0,0,1,1.4,1.1,5.23,5.23,0,0,1,.7,1.5,13.8,13.8,0,0,1,.2,2.5v7.5h-3.4V245a10.7,10.7,0,0,0-.2-2.5c-.1-.4-.4-.6-.7-.9a2.13,2.13,0,0,0-1.2-.3,2.41,2.41,0,0,0-1.5.4,2.94,2.94,0,0,0-1,1.2,7.38,7.38,0,0,0-.3,2.4v6.4H104V234.1h3.4Z",
    transform: "translate(-34.7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M121.5,242.9l-3.1-.6a4.37,4.37,0,0,1,1.8-2.7,6.45,6.45,0,0,1,3.8-.9,9.36,9.36,0,0,1,3.4.5,3.71,3.71,0,0,1,1.6,1.4,6.74,6.74,0,0,1,.5,3v3.9a14.73,14.73,0,0,0,.2,2.5,7,7,0,0,0,.6,1.7h-3.4a6.21,6.21,0,0,1-.3-1,.76.76,0,0,1-.1-.4,5.86,5.86,0,0,1-1.9,1.3,5.22,5.22,0,0,1-2.1.4,4.33,4.33,0,0,1-3.1-1.1,3.34,3.34,0,0,1-1.1-2.7,3.83,3.83,0,0,1,.5-1.9,2.78,2.78,0,0,1,1.5-1.3,9.77,9.77,0,0,1,2.7-.8,26.45,26.45,0,0,0,3.3-.8v-.3a2,2,0,0,0-.5-1.4,2.65,2.65,0,0,0-1.8-.4,2,2,0,0,0-1.4.4A1.67,1.67,0,0,0,121.5,242.9Zm4.6,2.7c-.4.1-1.1.3-2.1.5a5.93,5.93,0,0,0-1.9.6,1.52,1.52,0,0,0-.7,1.2,1.66,1.66,0,0,0,.5,1.2,2.17,2.17,0,0,0,1.4.5,3.23,3.23,0,0,0,1.8-.6,2.1,2.1,0,0,0,.8-1.1,6.22,6.22,0,0,0,.1-1.6l.1-.7Z",
    transform: "translate(-34.7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M138.4,239v2.7h-2.3v5.1a6.73,6.73,0,0,0,.1,1.8c0,.2.1.3.3.4a1.07,1.07,0,0,0,.6.2,5,5,0,0,0,1.4-.3l.3,2.6a7.63,7.63,0,0,1-2.7.5,4.67,4.67,0,0,1-1.7-.3,2.42,2.42,0,0,1-1.1-.8,3.92,3.92,0,0,1-.5-1.3,13.58,13.58,0,0,1-.1-2.4v-5.6h-1.6V239h1.6v-2.5l3.4-2V239Z",
    transform: "translate(-34.7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M139.3,248.1l3.4-.5a2,2,0,0,0,.9,1.5,3.31,3.31,0,0,0,1.9.5,3.68,3.68,0,0,0,2-.5,1,1,0,0,0,.4-.9.85.85,0,0,0-.2-.6,1.93,1.93,0,0,0-1.1-.4c-2.7-.6-4.5-1.1-5.2-1.6a3.27,3.27,0,0,1-1.5-2.9,3.54,3.54,0,0,1,1.3-2.8c.9-.8,2.2-1.1,4.1-1.1a6.59,6.59,0,0,1,3.9.9,4.66,4.66,0,0,1,1.8,2.5l-3.2.6a1.55,1.55,0,0,0-.8-1.1,2.54,2.54,0,0,0-1.6-.4,3.16,3.16,0,0,0-1.9.4.75.75,0,0,0-.4.7.86.86,0,0,0,.3.6,15.33,15.33,0,0,0,3.2.9,9.26,9.26,0,0,1,3.8,1.5,3.1,3.1,0,0,1,1.1,2.5,3.69,3.69,0,0,1-1.5,3,6.79,6.79,0,0,1-4.4,1.3,7.46,7.46,0,0,1-4.2-1.1A5.72,5.72,0,0,1,139.3,248.1Z",
    transform: "translate(-34.7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M170.2,251.7h-3.9l-1.6-4h-7.1l-1.5,4h-3.8l6.9-17.6H163Zm-6.7-6.9-2.4-6.5-2.4,6.5Z",
    transform: "translate(-34.7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M171.7,239h3.2v1.9a5.23,5.23,0,0,1,1.7-1.6,4.65,4.65,0,0,1,2.3-.6,5,5,0,0,1,3.8,1.7,7.3,7.3,0,0,1,1.6,4.8,7.16,7.16,0,0,1-1.6,5,4.93,4.93,0,0,1-3.8,1.8,3.81,3.81,0,0,1-1.9-.4,7.34,7.34,0,0,1-1.8-1.4v6.4h-3.4l-.1-17.6Zm3.4,6.2a4.89,4.89,0,0,0,.9,3.2,2.64,2.64,0,0,0,2.1,1,2.52,2.52,0,0,0,2-.9,5,5,0,0,0,.8-3.1,5.1,5.1,0,0,0-.8-3,2.61,2.61,0,0,0-2-1,2.64,2.64,0,0,0-2.1,1A3.4,3.4,0,0,0,175.1,245.2Z",
    transform: "translate(-34.7)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M186.6,239h3.2v1.9a5.23,5.23,0,0,1,1.7-1.6,4.65,4.65,0,0,1,2.3-.6,5,5,0,0,1,3.8,1.7,7.3,7.3,0,0,1,1.6,4.8,7.16,7.16,0,0,1-1.6,5,4.93,4.93,0,0,1-3.8,1.8,3.81,3.81,0,0,1-1.9-.4,7.34,7.34,0,0,1-1.8-1.4v6.4h-3.4l-.1-17.6Zm3.4,6.2a4.89,4.89,0,0,0,.9,3.2,2.64,2.64,0,0,0,2.1,1,2.52,2.52,0,0,0,2-.9,5,5,0,0,0,.8-3.1,5.1,5.1,0,0,0-.8-3,2.61,2.61,0,0,0-2-1,2.64,2.64,0,0,0-2.1,1A3.4,3.4,0,0,0,190,245.2Z",
    transform: "translate(-34.7)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhats);
export default __webpack_public_path__ + "static/media/phoneWhats.ee835d630109626287d7890da0da8cc1.svg";
export { ForwardRef as ReactComponent };